import React from 'react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
export function FinalCall() {
  return <section aria-labelledby="final-heading" className="bg-noir py-14 sm:py-24" data-id="element-97" data-mp="33luf8fkn2qih">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-98" data-mp="2ymrm9thxoaqv">
        <div data-id="element-99" data-mp="2tphlxit0aeo9">
          <p className="text-[10px] font-semibold uppercase tracking-label text-gold sm:text-[11px]" data-id="element-100" data-mp="2tq1512ue793v">
            Final countdown
          </p>
          <h2 id="final-heading" className="mt-4 font-display text-3xl font-semibold leading-[1.06] text-gold-light sm:text-5xl" data-id="element-101" data-mp="3md3y3fgaurmq">
            Complete package, launch price
          </h2>
          <div className="mt-7" data-id="element-102" data-mp="3dd77h8acnip1">
            <Countdown initialSeconds={86347} size="lg" tone="light" data-id="element-103" data-mp="3dbw1d1tflyur" />
          </div>
        </div>

        <div className="border border-wood bg-wood-dark p-6 sm:p-10" data-id="element-104" data-mp="260f4aaydgltr">
          <p className="text-xs uppercase tracking-label text-gold sm:text-sm" data-id="element-105" data-mp="21w7fyevtt7w2">
            6 Volumes + 5 Bonuses
          </p>
          <p className="mt-5 flex items-baseline gap-3" data-id="element-106" data-mp="i51rig4k5mt3">
            <span className="font-display text-5xl font-semibold leading-none text-paper sm:text-6xl" data-id="element-107" data-mp="n44rhm5ol2u7">
              $19
            </span>
            <span className="font-display text-xl leading-none text-paper-400 line-through" data-id="element-108" data-mp="93amzelr7m0t">
              $707
            </span>
          </p>
          <p className="mt-3 text-sm font-semibold text-gold-light" data-id="element-109" data-mp="3vjoieeivq963">You save $688 today</p>

          <div className="mt-7" data-id="element-110" data-mp="44qwd0w7tm24">
            <CtaButton size="lg" tone="gold" fullWidth data-id="element-111" data-mp="45sji3qi9z07">
              Yes, I want it now
            </CtaButton>
          </div>

          <ul className="mt-6 space-y-1.5 text-xs text-paper-400" data-id="element-112" data-mp="3ln211zpri08t">
            <li data-id="element-113" data-mp="3qld9q74bm4pg">Payment is one-time &middot; No subscription</li>
            <li data-id="element-114" data-mp="3ckkaxa6zkngj">Instant access to all materials</li>
            <li data-id="element-115" data-mp="3cl2i31v6sm38">7-day satisfaction guarantee</li>
          </ul>
        </div>
      </div>
    </section>;
}